<ng-container *ngIf="category_selected != category_general_services.id">
  <div class="row content__grid">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-t-15">
      <div class="row">
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-map-marked-alt bg-primary  text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Destinos turísticos</h5>
              </div>
              <h3 class="mt-4 f-s-25">{{count_tour}}<span class="dashboard__labelCard">tours registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-users bg-warning text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Clientes</h5>
              </div>
              <h3 class="mt-4 f-s-25">{{count_client}}<span class="dashboard__labelCard">registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-hotel bg-info text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Hoteles</h5>
              </div>
              <h3 class="mt-4 f-s-25">{{count_hotel}}<span class="dashboard__labelCard">registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-clipboard-check bg-success text-white"></i>
              </div>
              <div>
                <h5 class="f-s-16">N° Reservas mes</h5>
              </div>
              <h3 class="mt-4 f-s-20 m-b-16 bold">{{count_booking}} <span class="f-s-11"
                  style="font-weight: 500;">registros</span></h3>
              <span class="dashboard__tagmonth">{{date_result | date:'MMMM, YYYY'}}</span>
            </div>
          </div>
        </div>

        <!-- <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-chart-line bg-info text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Ingresos del día</h5>
              </div>
              <h3 class="mt-4 f-s-18 m-b-20 bold">S/ 100.00</h3>
              <span class="dashboard__tagmonth">12 JUNE, 2024</span>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10 dashboard__cardincome">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-donate bg-primary text-white"></i>
              </div>
              <div>
                <h5 class="f-s-16">Reservas x cobrar</h5>
              </div>
              <h3 class="mt-4 f-s-18 m-b-20 bold">+ S/ 2500</h3>
              <span class="dashboard__tagmonth">
                <a href="#" class="dashboard__tagmonth__link">ver registros <i class="fas fa-arrow-right"></i></a>
              </span>
            </div>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col-xl-6">
          <div class="card m-b-30">
            <div class="card-body">
              <h4 class="mt-0 header-title m-b-5">
                Llegadas confirmadas <span class="f-s-13">(Hoy y Mañana)</span>
                <a routerLink="/{{branchofficeSlug}}/reservas/llegadas/lista"
                  class="btn btn-success btn-sm float-right f-s-11">
                  Ir <span class="hide-xs">a módulo</span><i class="fas fa-arrow-right m-l-5"></i></a>
                <p class="text-muted f-s-10 m-b-0 m-t-2">
                  Recojo Programado <i class="fas fa-check-circle text-orange m-l-5 m-r-2"></i>
                  <span class="bold m-l-10"><i class="fas fa-info-circle parpadea m-l-10"></i> LLEGAN HOY</span></p>
              </h4>

              <div class="row">
                <div class="col-lg-3 col-4">
                  <span class="bold">Código</span>
                </div>
                <div class="col-lg-5 col-4">
                  <span class="bold">Cliente <span class="hide-xs">Responsable</span></span>
                </div>
                <div class="col-lg-4 col-4 text-left">
                  <span class="bold">Llegada</span>
                </div>
              </div>
              <div class="friends-suggestions" style="height: 300px; overflow-y: auto; overflow-x: hidden">
                <ng-container *ngIf="arrivals.length > 0">
                  <div class="friends-suggestions-list" *ngFor="let item of arrivals">
                    <div class="border-bottom position-relative row">
                      <div class="col-lg-3 col-4">
                        <div class="desc">
                          <h5 class="f-s-11 mb-1 pt-3 text-dark bold">{{item.code}}</h5>
                          <p *ngIf="item.is_scheduled_pickup" class="badge text-white f-s-9"
                            style="background-color: #fc6954 !important">programado</p>
                        </div>
                      </div>
                      <div class="col-lg-5 col-4">
                        <div class="desc">
                          <h5 class="f-s-12 mb-1 pt-2 text-dark">{{item.client_data.fullname}}</h5>
                          <p class="text-muted f-s-11">{{item.client_data.typeDocument}} : {{item.client_data.document}}
                          </p>
                        </div>
                      </div>
                      <div class="col-lg-4 col-4">
                        <div class="m-t-20 pt-1">
                          <p class="f-s-11 m-b-0">
                            <span *ngIf="date_result == item.date_arrival">
                              <i class="fas fa-info-circle parpadea m-l-10"></i>
                            </span>
                            {{item.date_arrival}}
                          </p>
                          <p class="f-s-11 m-b-0">Hora : {{item.time_arrival}}</p>
                          <i class="fas fa-plane-arrival m-r-5"></i>
                          <ng-container *ngIf="item.arrivalplace_id != null">
                            <span class="f-s-10 text-uppercase bold">{{item.arrivalplace_data.description}}</span>
                          </ng-container>
                          <ng-container *ngIf="item.arrival_place != null">
                            <span class="f-s-10 m-l-5">: {{item.arrival_place}}</span>
                          </ng-container>
                          <ng-container *ngIf="item.arrival_place == null">
                            <span class="f-s-9 m-l-5">No especifica datos.</span>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="arrivals.length == 0">
                  <p class="m-t-25">No se encontraron registros</p>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
            style="width: 100%; height: 400px; display: block;">
          </highcharts-chart>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-lg-6">
          <highcharts-chart [Highcharts]="Highchart" [options]="tourChartOptions"
            style="width: 100%; height: 400px; display: block;">
          </highcharts-chart>
        </div>
        <div class="col-lg-6">
          <div id="container_summary_billing"></div>
        </div>
      </div> -->
    </div>
  </div>
</ng-container>

<ng-container *ngIf="category_selected == category_general_services.id">
  <div class="row content__grid">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 m-t-15">
      <div class="row">
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-shopping-basket bg-primary  text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Productos</h5>
              </div>
              <h3 class="mt-4 f-s-25">{{count_product}}<span class="dashboard__labelCard">registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-users bg-warning text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Clientes</h5>
              </div>
              <h3 class="mt-4">{{count_client}}<span class="dashboard__labelCard">registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-store-alt bg-info text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Proveedores</h5>
              </div>
              <h3 class="mt-4">{{count_provider}}<span class="dashboard__labelCard">registrados</span></h3>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-xl-3">
          <div class="card">
            <div class="card-heading p-3 p-t-10 p-b-10">
              <div class="mini-stat-icon float-right">
                <i class="fas fa-chart-line bg-success text-white"></i>
              </div>
              <div>
                <h5 class="font-16">Ventas del mes</h5>
              </div>
              <h3 class="mt-4 f-s-19 m-b-20">{{total_sale_month | currency:'PEN'}}</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag"
            style="width: 100%; height: 400px; display: block;">
          </highcharts-chart>
        </div>
        <div class="col-lg-6">
          <highcharts-chart [Highcharts]="Highcharts" [options]="graphSummaryTypeVoucherOptions"
          style="width: 100%; height: 400px; display: block;">
        </highcharts-chart>
        </div>
      </div>
    </div>
  </div>
</ng-container>
